import { TiltChartConfigDto, ChartType, PracticePitcherSingleSessionReportChartConfigDto, TiltChartAxis } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

type ReportConfig = PracticePitcherSingleSessionReportChartConfigDto;

type Props<TReportConfig extends ReportConfig> = ChartConfigProps<TiltChartConfigDto, TReportConfig> & {
  chartId: ChartType;
  configKey: keyof TReportConfig;
};

const PracticePitcherSingleSessionTiltChartSidebar = <T extends ReportConfig>({
  chartConfig,
  setTempLayout,
  tempLayout,
  chartId,
  configKey,
}: Props<T>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle(chartId, chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['SpinAxis', 'MeasuredAxis'] satisfies TiltChartAxis[]}
        selected={chartConfig.axis}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            [configKey]: { ...tempLayout[configKey], axis: selected },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default PracticePitcherSingleSessionTiltChartSidebar;
